import { ROLES, type RoleStrategy } from "@pharmupp/p3-front-commons"
import { fields } from "./GeneralInfos.fields"

export const formRoleConf: RoleStrategy<Record<string, any>> = {
  [ROLES.ADMIN]: {
    create: {
      statusSection: {
        hide: true,
      },
    },
  },
  [ROLES.ADHERENT_HOLDER]: {
    [fields.type]: {
      disabled: true,
    },
    updateUserInformation: {
      [fields.type]: {
        disabled: true,
      },
      programmedDeactivationSection: {
        hide: true,
      },
    },
  },
  [ROLES.ADHERENT_TEAM]: {
    updateUserInformation: {
      [fields.type]: {
        disabled: true,
      },
      [fields.teamFunction]: {
        disabled: true,
      },
      [fields.email]: {
        disabled: true,
      },
      [fields.firstName]: {
        disabled: true,
      },
      [fields.lastName]: {
        disabled: true,
      },
      [fields.phone]: {
        disabled: true,
      },
      [fields.status]: {
        disabled: true,
      },
      [fields.function]: {
        disabled: true,
      },
      [fields.externSpecification]: {
        disabled: true,
      },
      [fields.programmedUnactivate]: {
        disabled: true,
      },
      [fields.unactivateDate]: {
        disabled: true,
      },
      [fields.birthName]: {
        disabled: true,
      },
      [fields.birthDate]: {
        disabled: true,
      },
      [fields.title]: {
        disabled: true,
      },
      programmedDeactivationSection: {
        hide: true,
      },
      [fields.rppsId]: {
        disabled: true,
      },
    },
  },
}

export const readOnlyConf = Object.keys(fields).reduce<Record<string, any>>(
  (result, current) => {
    result[current] = { disabled: true }
    return result
  },
  {},
)
